import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2cd249f0 from 'nuxt_plugin_plugin_2cd249f0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_39afd83c from 'nuxt_plugin_sentryserver_39afd83c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7d6ea25a from 'nuxt_plugin_sentryclient_7d6ea25a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_7823521e from 'nuxt_plugin_axios_7823521e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_632a4f19 from 'nuxt_plugin_image_632a4f19' // Source: ./image.js (mode: 'all')
import nuxt_plugin_fontawesome_700e96e0 from 'nuxt_plugin_fontawesome_700e96e0' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_ClickOutsideDirective_c78d4c9e from 'nuxt_plugin_ClickOutsideDirective_c78d4c9e' // Source: ../plugins/ClickOutsideDirective.ts (mode: 'all')
import nuxt_plugin_ImageFallbackDirective_6c5428b6 from 'nuxt_plugin_ImageFallbackDirective_6c5428b6' // Source: ../plugins/ImageFallbackDirective.ts (mode: 'all')
import nuxt_plugin_Axios_4ea506e6 from 'nuxt_plugin_Axios_4ea506e6' // Source: ../plugins/Axios.ts (mode: 'all')
import nuxt_plugin_setToken_14392040 from 'nuxt_plugin_setToken_14392040' // Source: ../plugins/setToken.ts (mode: 'all')
import nuxt_plugin_storeAccessor_16da3f5b from 'nuxt_plugin_storeAccessor_16da3f5b' // Source: ../plugins/storeAccessor.ts (mode: 'all')
import nuxt_plugin_LoadInSyncAI_453ab589 from 'nuxt_plugin_LoadInSyncAI_453ab589' // Source: ../plugins/LoadInSyncAI.ts (mode: 'client')
import nuxt_plugin_paypal_6f8d7ca4 from 'nuxt_plugin_paypal_6f8d7ca4' // Source: ../plugins/paypal.ts (mode: 'client')
import nuxt_plugin_clarity_3440f28f from 'nuxt_plugin_clarity_3440f28f' // Source: ../plugins/clarity.ts (mode: 'client')
import nuxt_plugin_floatingvue_09851550 from 'nuxt_plugin_floatingvue_09851550' // Source: ../plugins/floating-vue.ts (mode: 'client')
import nuxt_plugin_auth_181e9b52 from 'nuxt_plugin_auth_181e9b52' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bicycle Shipping Service - Bike Shipping Boxes - Best Way to Ship a Bike - Bikeflights.com","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":"Bikeflights.com is a bicycle shipping service. You get fast delivery, great prices and excellent service with every shipment per our Best Way Guarantee."},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.cdnfonts.com\u002Fcss\u002Fproxima-nova-2"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap"}],"script":[{"src":"\u002Ftracking\u002Fconsent.js","defer":false,"body":true},{"src":"\u002Ftracking\u002FmultiSite.js","defer":true,"body":true},{"src":"\u002Ftracking\u002Fbing.js","defer":true,"body":true},{"src":"\u002Ftracking\u002Faffiliate.js","defer":true,"body":true},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"style":[],"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2cd249f0 === 'function') {
    await nuxt_plugin_plugin_2cd249f0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_39afd83c === 'function') {
    await nuxt_plugin_sentryserver_39afd83c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7d6ea25a === 'function') {
    await nuxt_plugin_sentryclient_7d6ea25a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7823521e === 'function') {
    await nuxt_plugin_axios_7823521e(app.context, inject)
  }

  if (typeof nuxt_plugin_image_632a4f19 === 'function') {
    await nuxt_plugin_image_632a4f19(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_700e96e0 === 'function') {
    await nuxt_plugin_fontawesome_700e96e0(app.context, inject)
  }

  if (typeof nuxt_plugin_ClickOutsideDirective_c78d4c9e === 'function') {
    await nuxt_plugin_ClickOutsideDirective_c78d4c9e(app.context, inject)
  }

  if (typeof nuxt_plugin_ImageFallbackDirective_6c5428b6 === 'function') {
    await nuxt_plugin_ImageFallbackDirective_6c5428b6(app.context, inject)
  }

  if (typeof nuxt_plugin_Axios_4ea506e6 === 'function') {
    await nuxt_plugin_Axios_4ea506e6(app.context, inject)
  }

  if (typeof nuxt_plugin_setToken_14392040 === 'function') {
    await nuxt_plugin_setToken_14392040(app.context, inject)
  }

  if (typeof nuxt_plugin_storeAccessor_16da3f5b === 'function') {
    await nuxt_plugin_storeAccessor_16da3f5b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_LoadInSyncAI_453ab589 === 'function') {
    await nuxt_plugin_LoadInSyncAI_453ab589(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paypal_6f8d7ca4 === 'function') {
    await nuxt_plugin_paypal_6f8d7ca4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clarity_3440f28f === 'function') {
    await nuxt_plugin_clarity_3440f28f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_floatingvue_09851550 === 'function') {
    await nuxt_plugin_floatingvue_09851550(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_181e9b52 === 'function') {
    await nuxt_plugin_auth_181e9b52(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
